/**
 * Dynamically measure announcement bar and header height for slideshow calc.
 */
(function () {
  function measuredHeightPx(el) {
    if (!el) return 0;
    const h = el.getBoundingClientRect().height;
    return h > 0 ? h : 0;
  }

  function updateHeights() {
    const bar = document.querySelector('.announcement-bar-section');
    const header = document.querySelector('.header-section');
    const barHeight = measuredHeightPx(bar);
    const headerHeight = measuredHeightPx(header);
    document.documentElement.style.setProperty('--announcement-bar-height', barHeight + 'px');
    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
  }

  function updateAnnouncementScrolled() {
    const section = document.querySelector('.shopify-section.announcement-bar-section');
    if (!section) return;
    if (window.scrollY > 0) {
      section.classList.add('announcement-scrolled');
    } else {
      section.classList.remove('announcement-scrolled');
    }
  }

  function init() {
    updateHeights();
    updateAnnouncementScrolled();

    window.addEventListener('scroll', updateAnnouncementScrolled, { passive: true });

    const elements = document.querySelectorAll('.announcement-bar-section, .header-section');
    if (elements.length && typeof ResizeObserver !== 'undefined') {
      const observer = new ResizeObserver(updateHeights);
      elements.forEach(el => observer.observe(el));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
